import posthog from 'posthog-js';

// Funnel analytics for the marketing pages. Gated on REACT_APP_POSTHOG_KEY so local dev
// and CI stay silent — set the key in frontend/.env.local or in the Vercel env to enable.

let initialized = false;

export function initAnalytics(): void {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key || initialized) return;
  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: false,
    autocapture: false,
    persistence: 'localStorage',
  });
  initialized = true;
}

export function track(event: string, props?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.capture(event, props);
}

export function identify(distinctId: string, props?: Record<string, unknown>): void {
  if (!initialized) return;
  posthog.identify(distinctId, props);
}
